import { ApiResponse, ApiSuccessResponse } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import { logOut, setCredentials } from "./authSlice";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    riderApplication: builder.mutation<
      ApiSuccessResponse<any>,
      Record<string, any>
    >({
      query: (userData) => ({
        url: "/v1/ridderapplication/apply",
        method: "POST",
        body: { ...userData },
      }),
    }),
    login: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>({
      query: (credentials) => ({
        url: "/webtokens",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    sendLogout: builder.mutation<ApiSuccessResponse<any>, Record<string, any>>({
      query: () => ({
        url: "/webtokens/logout",
        method: "POST",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(logOut());
          setTimeout(() => {
            dispatch(apiSlice.util.resetApiState());
          }, 1000);
        } catch (err) {
          console.log(err);
        }
      },
    }),
    refresh: builder.mutation<ApiSuccessResponse<any>, void>({
      query: () => ({
        url: "/webtokens/refresh",
        method: "POST",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          dispatch(
            setCredentials({
              accessToken: data?.data?.token,
              user: data?.data?.userDetails,
              permissions: data?.data?.permissions,
            })
          );
        } catch (err) {
          console.log(err);
        }
      },
    }),
    getUser: builder.query<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/personal/profile`,
        method: "GET",
      }),
      transformResponse: (response: ApiResponse<any>) => {
        return response.data;
      },
    }),
    getUserPermission: builder.query<ApiSuccessResponse<any>, string>({
      query: () => ({
        url: `/personal/permission`,
        method: "GET",
      }),
    }),
    riderApplicationStatus: builder.query<ApiSuccessResponse<any>, string>({
      query: (id) => ({
        url: `/v1/ridderapplication/status?TrackingId=${id}`,
        method: "GET",
      }),
    }),
    updateUser: builder.mutation<void, Record<string, any>>({
      query: (userData) => ({
        url: "/user/update-user",
        method: "PUT",
        body: { ...userData },
      }),
    }),
    forgotPassword: builder.mutation<ApiSuccessResponse<any>, { email: string }>({
      query: (body) => ({
        url: "/users/forgot-password",
        method: "POST",
        body,
      }),
    }),
    resetPassword: builder.mutation<
      ApiSuccessResponse<any>,
      { email: string; password: string; token: string }
    >({
      query: (body) => ({
        url: "/users/reset-password",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useRiderApplicationMutation,
  useLoginMutation,
  useSendLogoutMutation,
  useRefreshMutation,
  useGetUserQuery,
  useGetUserPermissionQuery,
  useRiderApplicationStatusQuery,
  useUpdateUserMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
} = authApiSlice;
